var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconEditorPublishing(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 22 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.0001 0.5C6.00006 0.5 1.73006 3.61 6.10352e-05 8C1.73006 12.39 6.00006 15.5 11.0001 15.5C16.0001 15.5 20.2701 12.39 22.0001 8C20.2701 3.61 16.0001 0.5 11.0001 0.5ZM11 2.49997C14.79 2.49997 18.17 4.62997 19.82 7.99997C18.17 11.37 14.79 13.5 11 13.5C7.20998 13.5 3.82998 11.37 2.17998 7.99997C3.82998 4.62997 7.20998 2.49997 11 2.49997ZM6.50003 8C6.50003 5.52 8.52003 3.5 11 3.5C13.48 3.5 15.5 5.52 15.5 8C15.5 10.48 13.48 12.5 11 12.5C8.52003 12.5 6.50003 10.48 6.50003 8Z",
    fill: "#334D6E"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconEditorPublishing);
export default __webpack_public_path__ + "static/media/icon-editor-publishing.0154581cf608977106850416252d247c.svg";
export { ForwardRef as ReactComponent };